"use client";

import { Link } from "react-router-dom";
import { useLanguage } from "@/i18n/LanguageContext";

interface NmbHeroProps {
  h1?: string;
  subhead?: string;
  zips?: string[];
}

export default function NmbHero({ h1, subhead, zips }: NmbHeroProps) {
  const { t, currentLang } = useLanguage();

  return (
    <section className="w-full bg-[#fefce8] py-20" style={{ minHeight: "70vh" }}>
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-10 px-5 lg:flex-row">
        <div className="flex flex-col gap-6 lg:w-[60%]">
          <p className="text-sm font-semibold uppercase tracking-widest text-[#047857]">
            {currentLang === "es" ? "Reparaci\u00F3n de Ventanas North Miami Beach" : "North Miami Beach Window Repair"}
          </p>
          <h1 className="text-5xl font-bold leading-tight text-[#064e3b]">
            {h1 || t("northMiamiBeach.h1")}
          </h1>
          <p className="max-w-xl text-base leading-relaxed text-[#064e3b]/80">
            {subhead || t("northMiamiBeach.subhead")}
          </p>
          {zips && zips.length > 0 && (
            <div className="flex flex-wrap gap-2">
              {zips.map((zip) => (
                <span key={zip} className="inline-flex items-center gap-1.5 bg-white text-[#064e3b] px-3 py-1.5 text-xs font-bold rounded-full border border-[#064e3b]/10">
                  <i className="ri-map-pin-line" />
                  {zip}
                </span>
              ))}
            </div>
          )}
          <div className="flex flex-wrap gap-4">
            <a
              href="tel:+17863774452"
              className="inline-flex items-center gap-2 bg-[#ea580c] text-white px-8 py-3 text-sm font-semibold rounded-[14px] hover:bg-[#c2410c] transition-colors whitespace-nowrap"
            >
              <i className="ri-phone-line" />
              {currentLang === "es" ? "Llame al (786) 377-4452" : "Call (786) 377-4452"}
            </a>
            <Link
              to="/contact/"
              className="inline-flex items-center gap-2 border-2 border-[#064e3b] text-[#064e3b] px-8 py-3 text-sm font-semibold rounded-[14px] hover:bg-[#064e3b] hover:text-white transition-colors whitespace-nowrap"
            >
              {currentLang === "es" ? "Obtener Cotizaci\u00F3n" : "Get Phone Quote"}
            </Link>
          </div>
        </div>
        <div className="lg:w-[40%]">
          <img
            src="https://storage.readdy-site.link/project_files/76915537-ee3f-4564-9a23-41bd98b5df27/2edcc15e-5d50-48bf-b8b4-496d36b55ebf_Sliding-Door-Repairs-2-scaled-min.jpg?v=d9723801fb14be4f7e8829cbb7dcfe2a"
            alt={currentLang === "es" ? "Servicio de reparaci\u00F3n de ventanas en North Miami Beach" : "North Miami Beach window repair family home service"}
            className="h-auto w-full rounded-[14px] object-cover"
            onError={(e) => {
              (e.target as HTMLImageElement).src =
                "https://storage.readdy-site.link/project_files/76915537-ee3f-4564-9a23-41bd98b5df27/2edcc15e-5d50-48bf-b8b4-496d36b55ebf_Sliding-Door-Repairs-2-scaled-min.jpg?v=d9723801fb14be4f7e8829cbb7dcfe2a";
            }}
          />
        </div>
      </div>
    </section>
  );
}